import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Accordion from "../components/Accordion";
import FullscreenLoader from "../components/FullscreenLoader";
import ToggleSwitch from "../components/ToggleSwitch";
import parse from "html-react-parser";
import { useTranslation } from "react-i18next";
import { } from "../providers/NewReportProvider";
import { ApplicationType, FormDataType, ReportType, SummaryType } from "../helpers/types";

type Props = {
    section: SummaryType;
    formData: FormDataType;
    application: ApplicationType | ReportType;
    consentApproved: boolean;
    setConsentApproved: (value: boolean) => void;
    type: 'application' | 'report';
    editBasePath: string;
}

const Summary = (props: Props) => {
    const { section, formData, application, consentApproved, setConsentApproved, editBasePath } = props;
    const { t } = useTranslation();
    if (!section) return <FullscreenLoader />

    const Header = () => {
        const { title, subtitle, introtext } = section;

        return (
            <div className="my-4 my-lg-5">
                <div className="d-flex justify-content-between align-items-start">
                    <div>
                        <p className="mb-1">{title}</p>
                        <h6>{subtitle}</h6>
                    </div>
                    <a
                        href="#"
                        className="no-print text-primary fw-medium text-decoration-none unbreakable"
                        onClick={(e) => {
                            e.preventDefault();
                            window.print();
                        }}
                    >
                        {t('print')}
                        <FontAwesomeIcon icon={['fal', 'print']} className="ms-2" />
                    </a>
                </div>
                {introtext && <span className="small">{parse(introtext)}</span>}
            </div>
        )
    }

    return (
        <>
            <Header />
            <Accordion
                formData={formData}
                application={application}
                showEditButton={true}
                editBasePath={editBasePath}
            />
            <div className="mt-3">
                <div className="alert alert-light">
                    <b className="fw-semibold">Samtykke</b>
                    <ToggleSwitch
                        label={section.consent?.btnlabel ?? 'Jeg samtykker'}
                        value={consentApproved}
                        onCheck={setConsentApproved}
                        description={section.consent?.text}
                    />
                </div>
            </div>
        </>
    )
}

export default Summary;
